import { z } from 'zod';

/** Standard profile attributes (BB-26): fixed keys stored in `profile` columns; only `set`/`unset` apply. */
export const STANDARD_ATTRIBUTES = [
  { key: '$email', column: 'email', pii: 'pii' },
  { key: '$phone', column: 'phone', pii: 'pii' },
  { key: '$first_name', column: 'firstName', pii: 'pii' },
  { key: '$last_name', column: 'lastName', pii: 'pii' },
  { key: '$language', column: 'language', pii: 'none' },
  { key: '$country', column: 'country', pii: 'none' },
  { key: '$timezone', column: 'timezone', pii: 'none' },
  { key: '$date_of_birth', column: 'dateOfBirth', pii: 'pii' },
] as const;
export type StandardAttributeKey = (typeof STANDARD_ATTRIBUTES)[number]['key'];

export const AttributeDataType = z.enum(['string', 'number', 'boolean', 'time', 'array', 'object']);
export type AttributeDataType = z.infer<typeof AttributeDataType>;

/** Custom attribute key: case-sensitive, no `$` prefix, no `.` (jsonb paths stay unambiguous). */
export const CustomAttributeKey = z
  .string()
  .min(1)
  .max(255)
  .refine((k) => !k.startsWith('$'), 'reserved_attribute_key')
  .refine((k) => !k.includes('.'), 'attribute_key_with_dot');
